import styled from 'styled-components';
import { ButtonProps } from './types';

export const ButtonBase = styled.button<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.5rem;
  background-color: transparent;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  outline: none;
  border: none;

  &:focus,
  &:hover {
    outline: none;
  }
`;

export const Button = styled(ButtonBase)<ButtonProps>`
  width: 100%;
  height: 2.2rem;
  color: ${({ secondary }) => (secondary ? '#800020' : '#fff')};
  background-color: ${({ secondary }) =>
    secondary ? 'transparent' : 'rgba(105, 15, 37, 0.93)'};
  border: ${({ secondary }) => (secondary ? `1px solid #FFB6C1` : 'none')};
  border-radius: 4px;
  font-size: 12px;

  &:not(:disabled):hover,
  &:not(:disabled):focus {
    background-color: ${({ secondary }) =>
      secondary ? '#D3D3D3' : 'rgba(100, 0, 25, 0.93)'};
    border: ${({ secondary }) =>
      secondary ? `1px solid rgb(238, 219, 222)` : 'none'};
  }

  &:disabled {
    background-color: rgb(184, 180, 180);
    color: #800020;
    cursor: not-allowed;
  }

  &:hover {
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.95);
  }

  & > svg {
    margin-right: 0.5rem;
  }
`;

export const IconButton = styled(ButtonBase)`
  padding: 0;
`;
